var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarLeadLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2E2D79",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.31.403s13.604-.846 18.4 17.994M12.075 15.852L18.803 19.327 22.446 12.683",
    transform: "translate(-77 -1312) scale(-1 1) rotate(5 -15086.774 -489.64)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLeadLeftArrow);
export default __webpack_public_path__ + "static/media/car-lead-left-arrow.aca4cedd3d4c82c95966258a4df08a99.svg";
export { ForwardRef as ReactComponent };